import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
/**
 *
 * TextField
 *
 */

/* eslint react/textfield-has-type: off */

import React from 'react';
import classnames from 'classnames';
import shortid from 'shortid';
import validationClass from '../../../../core/validations';
import Input from '../../../atoms/Input';
import Label from '../../../atoms/Label';

var TextField = function TextField(_ref) {
  var ariaLabel = _ref.ariaLabel,
      disabled = _ref.disabled,
      dataInputMask = _ref.dataInputMask,
      fieldSize = _ref.fieldSize,
      id = _ref.id,
      inputValue = _ref.inputValue,
      label = _ref.label,
      name = _ref.name,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      type = _ref.type,
      validationType = _ref.validationType,
      isControlled = _ref.isControlled,
      className = _ref.className,
      extraProps = _objectWithoutProperties(_ref, ["ariaLabel", "disabled", "dataInputMask", "fieldSize", "id", "inputValue", "label", "name", "onFocus", "onBlur", "onChange", "type", "validationType", "isControlled", "className"]);

  return React.createElement(React.Fragment, null, label && React.createElement(Label, {
    htmlFor: id
  }, label), React.createElement(Input, _extends({
    "aria-label": ariaLabel,
    className: classnames(className, dataInputMask, fieldSize, validationClass(validationType)),
    disabled: disabled,
    id: id,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    type: type,
    value: inputValue
  }, extraProps)));
};
/* instabul ignore next */


TextField.defaultProps = {
  disabled: false,
  dataInputMask: '',
  fieldSize: 'medium',
  id: shortid.generate(),
  inputValue: '',
  label: '',
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  type: 'text'
};
TextField.displayName = 'TextField';
export default TextField;